<template>
  <modal ref='import' id="import-contacts-modal">
    <template #header>
      <h5 class="modal-title mt-0">{{$t('contacts.import_modal.header')}}</h5>
    </template>

    <template #body>
      <form @submit.prevent='parseOrImportCSV($event)' @reset='clearImportData'>
        <div class="modal-body">
          <div class="form-group">
            <input type="file" name="file" class="form-control" accept="plain/text, text/csv" />
          </div>

          <p>
            {{$t('contacts.import_modal.download')}}
            <a href="/contacts-template.csv">
              {{ $t('contacts.import_modal.sample_csv_template') }}
            </a>
            {{$t('contacts.import_modal.csv_text_help')}}
          </p>

          <div v-if='dataToImport.errors.length'>
            {{$t('contacts.import_modal.total_errors', {errors: dataToImport.errors.length})}}
          </div>

          <div v-if='dataToImport.errors.length'>
            <ul>
              <li v-for='error in dataToImport.errors.slice(0, 5)'>
                {{ error }}
              </li>
            </ul>
          </div>

          <p v-if='dataToImport.progress'>
            <strong>{{$t('contacts.import_modal.progress')}}</strong>
             {{ dataToImport.progress }}%
          </p>

          <p v-if='dataToImport.data.length'>
            <strong>{{$t('contacts.import_modal.total_contacts')}}:</strong>
             {{ dataToImport.data.length }}
          </p>

          <table v-if='dataToImport.data.length' class="table">
            <thead>
              <tr>
                <th>{{$t('contacts.import_modal.contact_name')}}</th>
                <th>{{$t('contacts.import_modal.email')}}</th>
                <th>{{$t('contacts.import_modal.language')}}</th>
                <th>{{$t('contacts.import_modal.company')}}</th>
                <th>{{$t('contacts.import_modal.position')}}</th>
                <th>{{$t('contacts.import_modal.company_address')}}</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for='(row, index) in dataToImport.data.slice(0, 5)' :key='index'>
                <td v-for='(cell, index) in row' :key='index'>
                  {{cell}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div  class='modal-footer'>
          <input v-if='dataToImport.isParsing' type='reset' :value="$t('contacts.import_modal.reset')" class="btn btn-outline-primary">
          <input v-if='dataToImport.progress === 100' type='submit' :value="$t('contacts.import_modal.import')" class="btn btn-primary">
          <input v-else type='submit' :value="$t('contacts.import_modal.preview')" class="btn btn-primary">
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import _modal from '../_modal'
  import Papa from 'papaparse'

  export default {
    components: {
      'modal': _modal,
    },
    data() {
      return {
        dataToImport: {
          data: [],
          errors: [],
          progress: null,
          isParsing: false
        }
      }
    },
    methods: {
      open() {
        this.$refs.import.open()
      },
      close() {
        this.clearImportData()
        this.$refs.import.close()
      },
      parseOrImportCSV(event) {
        if (this.dataToImport.progress === 100) {
          this.importCSV()
        } else {
          this.parseCSV(event)
        }
      },
      parseCSV(event) {
        let file = new FormData(event.target).get('file')

        if (file && file.size === 0)
          return

        this.dataToImport.isParsing = true

        Papa.parse(file, {
          worker: true,
          skipEmptyLines: true,
          step: (results) => {
            this.dataToImport.data.push(Object.values(results.data))
            this.dataToImport.progress = results.meta.cursor / file.size * 100
            this.dataToImport.errors = results.errors.map(({message}) => message)
          },
          complete: () => {
            this.dataToImport.progress = 100
          }
        })
      },
      clearImportData() {
        this.dataToImport = {
          data: [],
          errors: [],
          progress: null,
          isParsing: false
        }
      },
      importCSV() {
        let params = { contacts: this.dataToImport.data.map(([name, email, locale, company, position, address]) => (
          { name: name,
            email: email,
            locale: locale,
            company: company,
            position: position,
            address: address})) }

        this.store.createContactsBulk(params).then(({data}) => {
          this.store.getContacts()
          this.store.sendMetrics({name: 'import_products_from_csv', params: this.$route.params, path: this.$route.fullPath})
          let message = `We imported ${data.success} contacts`

          if (data.failures > 0)
            message += ` but ${data.failures} failed`

          this.$toastr.success(message)
        })

        this.close()
        this.$toastr.success('We started importing your contacts')
      }
    }
  }
</script>
